<template>
  <v-row no-gutters class="pa-3" align="center" justify="center">
    <v-container class="mx-auto">
      <div class="height-spacer"></div>
      <v-card-title class="containertext">
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.password-recovery.right.title") }}
        </h1>
        <h1 id="text01pass" class="h36-medium white--text mb-5">
          {{ $t("homepage.password-recovery.right.title2") }}
        </h1>
      </v-card-title>

      <!-- PASSWORD RECOVERY FORM -->
      <v-card-text>
        <v-form
          ref="pwdRecoveryForm"
          v-model="pwdRecoveryValid"
          lazy-validation
        >
          <v-text-field
            v-model="username"
            :label="
              $t('homepage.password-recovery.right.form.personal-data.username')
            "
            :rules="[rules.required]"
            dark
          ></v-text-field>
        </v-form>
      </v-card-text>

      <!-- ACTIONS BUTTONS -->
      <v-card-actions id="actionbuttons" class="pa-3">
        <v-btn
          class="backbtn"
          @click="goToLogin"
          rounded
          outlined
          color="white"
        >
          {{
            $t("homepage.password-recovery.right.form.backToLoginButtonLabel")
          }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!pwdRecoveryValid"
          @click="sendPasswordRecoveryRequest()"
          class="importantbutton"
          rounded
        >
          <span class="font-weight-bold white--text">
            {{ $t("homepage.password-recovery.right.form.confirmButtonLabel") }}
          </span>
        </v-btn>
      </v-card-actions>
      <!-- <v-divider class="my-6 mx-3"></v-divider>
      <v-card-actions id="notregcard" class="pt-4 ml-2">
        <v-row no-gutters>
          <div
            id="notregscript"
            class="v-toolbar__title my-v-toolbar__title-inherit font-weight-light white--text"
          >
            {{ $t("homepage.not-register") }}
          </div>
          <v-btn
            id="btnconvpass"
            class="ml-1 mr-0 importantbutton"
            rounded
            @click="goToAgreementRequest"
            >{{ $t("homepage.request-agreement") }}</v-btn
          >
        </v-row>
      </v-card-actions> -->
    </v-container>
  </v-row>
</template>

<script>
import ValidationRules from "../../views/validationRules";
let vrules = new ValidationRules();

export default {
  data() {
    return {
      errorHeadline: "dialog.error.cardTitle",
      closeErrorButtonText: "dialog.error.closeButtonLabel",
      pwdRecoveryValid: true,
      rules: vrules,
      portaleConvenzioniUrl: process.env.VUE_APP_PORTALE_CONVENZIONI_URL
    };
  },
  computed: {
    username: {
      get() {
        return this.$store.getters["passwordRecovery/username"];
      },
      set(value) {
        this.$store.commit("passwordRecovery/updateUsername", value);
      }
    },
    errorDialog() {
      return this.$store.getters["error/errorDialog"];
    },
    pwdReq() {
      return this.$store.getters["passwordRecovery/passwordRecoveryRequest"];
    }
  },
  beforeCreate() {},
  created() {
    this.$store.commit("success/RESET", {
      root: true
    });
    this.$store.commit("passwordRecovery/RESET");
    this.$store.dispatch("passwordRecovery/initPasswordRecoveryRequest");
  },
  methods: {
    goToAgreementRequest() {
      window.location.href =
        this.portaleConvenzioniUrl.concat("/agreementRequest");
    },
    closeErrorDialog() {
      this.$store.commit("error/RESET");
    },
    goToLogin() {
      this.$store.dispatch("passwordRecovery/goBackToLogin");
    },
    sendPasswordRecoveryRequest() {
      if (this.$refs.pwdRecoveryForm.validate()) {
        this.$store.dispatch("passwordRecovery/sendPasswordRecoveryRequest");
      }
    }
  }
};
</script>

<style scoped>
/*  Start Responsive screen + Specific Mobile & Tablets */

@media only screen and (min-width: 1527px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 5px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
}

@media screen and (max-width: 1526px) and (min-width: 1524px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 5px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
}

@media screen and (max-width: 1524px) and (min-width: 1513px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 3px !important;
    padding-left: 11.8px !important;
    padding-right: 11.8px !important;
  }
}

@media screen and (max-width: 1512px) and (min-width: 1509px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 2.5px !important;
    padding-left: 11px !important;
    padding-right: 11px !important;
  }
}

@media screen and (max-width: 1508px) and (min-width: 1504px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 2.5px !important;
    padding-left: 11px !important;
    padding-right: 11px !important;
  }
}

@media screen and (max-width: 1504px) and (min-width: 1500px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 2.2px !important;
    padding-left: 10.2px !important;
    padding-right: 10.2px !important;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1494px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 1px !important;
    padding-left: 9px !important;
    padding-right: 9px !important;
  }
}

@media screen and (max-width: 1494px) and (min-width: 1480px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 1px !important;
    padding-left: 7.6px !important;
    padding-right: 7.6px !important;
  }
}

@media screen and (max-width: 1480px) and (min-width: 1477px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 1px !important;
    padding-left: 6.5px !important;
    padding-right: 6.5px !important;
  }
}

@media screen and (max-width: 1477px) and (min-width: 1473px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #btnconvpass {
    margin-bottom: 18px !important;
    margin-left: 0.5px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
}

@media screen and (max-width: 1472px) and (min-width: 1401px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1472px) and (min-width: 1402px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1402px) and (min-width: 1400px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 78px !important;
    padding-right: 78px !important;
  }
}

@media screen and (max-width: 1400px) and (min-width: 1380px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 78px !important;
    padding-right: 78px !important;
  }
}

@media screen and (max-width: 1380px) and (min-width: 1350px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 78px !important;
    padding-right: 78px !important;
  }
}

@media screen and (max-width: 1350px) and (min-width: 1300px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }
}

@media screen and (max-width: 1300px) and (min-width: 1240px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}

@media screen and (max-width: 1240px) and (min-width: 1200px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1160px) {
  .backbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 45px !important;
    padding-right: 45px !important;
  }
}

@media screen and (max-width: 1160px) and (min-width: 1130px) {
  .backbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

@media screen and (max-width: 1130px) and (min-width: 1090px) {
  .backbtn {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 35px !important;
    padding-right: 35px !important;
  }
}

@media screen and (max-width: 1090px) and (min-width: 1050px) {
  .backbtn {
    padding-left: 25px !important;
    padding-right: 25px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 25px !important;
    padding-right: 25px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }
}

@media screen and (max-width: 1050px) and (min-width: 1000px) {
  .backbtn {
    padding-left: 25px !important;
    padding-right: 25px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 25px !important;
    padding-right: 25px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media screen and (max-width: 1000px) and (min-width: 960px) {
  .backbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 12px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-left: 15px !important;
    margin-left: 3px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
}

@media screen and (max-width: 959px) and (min-width: 950px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 950px) and (min-width: 920px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 920px) and (min-width: 900px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 900px) and (min-width: 880px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 880px) and (min-width: 850px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 850px) and (min-width: 800px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

/*Specific Responsive Screen 800px*/

@media only screen and (max-width: 800px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

/*End Specific Responsive Screen 800px*/

@media screen and (max-width: 799px) and (min-width: 740px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 740px) and (min-width: 700px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 50px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 700px) and (min-width: 660px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 40px !important;
    padding-left: 65px !important;
    padding-right: 65px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 660px) and (min-width: 600px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 25px !important;
    padding-left: 45px !important;
    padding-right: 45px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 600px) and (min-width: 570px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 20px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 570px) and (min-width: 550px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 550px) and (min-width: 530px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 5px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 530px) and (min-width: 507px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 4px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }
}

@media screen and (max-width: 507px) and (min-width: 481px) {
  .backbtn {
    padding-left: 60px !important;
    padding-right: 60px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 60px !important;
    padding-right: 60px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 87px !important;
    padding-right: 87px !important;
  }
}

/*Specific Responsive Screen 480px*/

@media only screen and (max-width: 480px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }
}

/*End Specific Responsive Screen 480px*/

@media screen and (max-width: 479px) and (min-width: 460px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 75px !important;
    padding-right: 75px !important;
  }
}

/*Specific Responsive Screen 460px*/

@media screen and (max-width: 479px) and (min-width: 460px) {
  .backbtn {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }
}

/*End Specific Responsive Screen 460px*/

@media screen and (max-width: 459px) and (min-width: 440px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}

@media screen and (max-width: 440px) and (min-width: 436px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}

/*Specific Responsive Screen 435px*/

@media only screen and (max-width: 435px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}

/*End Specific Responsive Screen 435px*/

@media screen and (max-width: 434px) and (min-width: 424px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

@media screen and (max-width: 424px) and (min-width: 413px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

/*Specific Responsive Screen 412&411px*/

@media screen and (max-width: 412px) and (min-width: 411px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

/*End Specific Responsive Screen 412&411px*/

@media screen and (max-width: 410px) and (min-width: 390px) {
  .backbtn {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

@media screen and (max-width: 390px) and (min-width: 370px) {
  .backbtn {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}

/*Specific Responsive Screen 375px*/

@media only screen and (max-width: 375px) {
  .backbtn {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 30px !important;
    padding-right: 30px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}

/*End Specific Responsive Screen 375px*/

@media screen and (max-width: 370px) and (min-width: 350px) {
  .backbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media screen and (max-width: 350px) and (min-width: 330px) {
  .backbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media screen and (max-width: 330px) and (min-width: 320px) {
  .backbtn {
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  .importantbutton {
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

@media screen and (max-width: 320px) and (min-width: 300px) {
  .backbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 3px !important;
    margin-left: 3px !important;
  }

  .importantbutton {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 3px !important;
    margin-left: 3px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .containertext {
    padding-left: 12px !important;
    padding-right: 0px !important;
  }
}

@media screen and (max-width: 300px) and (min-width: 280px) {
  .backbtn {
    padding-left: 70px !important;
    padding-right: 70px !important;
    margin-left: 3px !important;
    margin-bottom: 30px !important;
  }

  .importantbutton {
    padding-left: 65px !important;
    padding-right: 65px !important;
    margin-left: 3px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 14px !important;
    padding-right: 14px !important;
    font-size: 11px !important;
  }

  .containertext {
    padding-left: 12px !important;
    padding-right: 0px !important;
  }

  #actionbuttons {
    display: block !important;
  }
}
@media screen and (max-width: 280px) and (min-width: 270px) {
  .backbtn {
    padding-left: 60px !important;
    padding-right: 60px !important;
    margin-left: 3px !important;
    margin-bottom: 30px !important;
  }

  .importantbutton {
    padding-left: 55px !important;
    padding-right: 55px !important;
    margin-left: 3px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 11px !important;
  }

  .containertext {
    padding-left: 12px !important;
    padding-right: 0px !important;
    width: 82% !important;
  }

  #actionbuttons {
    display: block !important;
  }
}

/*Sizes less than 270px*/

@media screen and (max-width: 270px) and (min-width: 260px) {
  .backbtn {
    padding-left: 49px !important;
    padding-right: 49px !important;
    margin-left: 3px !important;
    margin-bottom: 30px !important;
  }

  .importantbutton {
    padding-left: 45px !important;
    padding-right: 45px !important;
    margin-left: 3px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 10px !important;
  }

  .containertext {
    padding-left: 12px !important;
    padding-right: 0px !important;
    width: 100% !important;
  }

  #actionbuttons {
    display: block !important;
  }

  #text01pass {
    font-size: 30px !important;
  }
}

@media screen and (max-width: 260px) and (min-width: 240px) {
  .backbtn {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-left: 3px !important;
    margin-bottom: 30px !important;
  }

  .importantbutton {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 3px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #btnconvpass {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 9px !important;
  }

  .containertext {
    padding-left: 12px !important;
    padding-right: 0px !important;
    width: 100% !important;
  }

  #actionbuttons {
    display: block !important;
  }

  #text01pass {
    font-size: 25px !important;
  }
}
</style>
